(function () {
  const sections = document.querySelectorAll('[data-recipes-cards]');
  if (!sections.length) return;

  sections.forEach((section) => {
    section.classList.add('frc-recipes-js');

    const revealItems = section.querySelectorAll('.frc-recipes-reveal, .frc-recipes-reveal-scale');
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('frc-recipes-is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, {
      threshold: 0.14,
      rootMargin: '0px 0px -48px 0px'
    });

    revealItems.forEach((item, index) => {
      if (!item.style.getPropertyValue('--frc-delay')) {
        item.style.setProperty('--frc-delay', `${index * 85}ms`);
      }
      revealObserver.observe(item);
    });
  });
})();